import setupSlider from './common/slider';

const SELECTORS = Selectors({
    slide: '[data-benefit-slide]',
    slider: '.benefits__slider',
    track: '[data-glide-el]',
});

const slides = document.querySelectorAll(SELECTORS.slide);
const track = document.querySelector(SELECTORS.track);

const fn = {
    init: () => {
        fn.setupBenefitsSlide();
    },

    setupBenefitsSlide: () => {
        const slider = document.querySelector(SELECTORS.slider);
        const options = {
            type: 'carousel',
            perView: 7,
            focusAt: 'center',
            startAt: 2,
            gap: 10,
            peek: {
                before: 5,
                after: 5,
            },
            autoplay: 5000,
            // autoplay: false,
            breakpoints: {
                1919: {
                    perView: 5,
                },
                1600: {
                    perView: 4,
                },
                1200: {
                    perView: 3,
                },
                768: {
                    perView: 2,
                },
                480: {
                    perView: 1,
                },
            },
        };
        setupSlider(slider, options);
    },
};

export default {
    can: () => slides.length,
    run: fn.init,
};
